import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-communication-guideline',
  templateUrl: './communication-guideline.component.html',
  styleUrls: ['./communication-guideline.component.scss']
})
export class CommunicationGuidelineComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<CommunicationGuidelineComponent>) { }

  ngOnInit() {
  }
  close() {
    this.dialogRef.close()
  }
}
